import moment from "moment";
import { useState } from "react";
import { getTitleCase } from "../../../utils/utilityFunctions/stringUtility";
import LabelComponent from "../../UniversalComponents/LabelComponent";
import InputComponent from "../../UniversalComponents/InputComponent";
import SelectComponent from "../../UniversalComponents/SelectComponent";
import Button from "../../UniversalComponents/DefaultButton";

const CheckTypeAndReturnHtmlInput = ({ id, name, metaType, type, placeholder, value, onChange, options }) => {
  const [inputTypeData, setInputTypeData] = useState(value);

  if (type === "text") {
    if (metaType === "Hyperlink") {
      return (
        <>
          <LabelComponent
            className="w-1/2 bg-[#F1F6F9] flex items-center py-1 px-3"
            htmlFor={id || name}
            labelText={name}
            size="small"
          />
          <InputComponent
            className="w-1/2"
            height="100%"
            id={id || name}
            type="text"
            placeholder={placeholder || `Enter Name`}
            value={inputTypeData?.textForUrl}
            onChange={(event) => {
              setInputTypeData({ ...inputTypeData, textForUrl: event?.target?.value });
              onChange({ ...inputTypeData, textForUrl: event?.target?.value });
            }}
            inputClassName="rounded-none border-none"
          />
          <div className="block pb-[3px]"></div>
          <InputComponent
            className="w-1/2"
            height="100%"
            id={id || name}
            type="text"
            placeholder={placeholder || `Enter URL`}
            value={inputTypeData?.url}
            onChange={(event) => {
              setInputTypeData({ ...inputTypeData, url: event?.target?.value });
              onChange({ ...inputTypeData, url: event?.target?.value });
            }}
            inputClassName="rounded-none border-none"
          />
        </>
      );
    } else {
      return (
        <>
          <LabelComponent
            className="w-1/2 bg-[#F1F6F9] flex items-center py-1 px-3"
            htmlFor={id || name}
            labelText={name}
            size="small"
          />
          <InputComponent
            className="w-1/2"
            height="100%"
            id={id || name}
            type={type}
            placeholder={placeholder || `Enter ${name}`}
            value={inputTypeData}
            onChange={(event) => {
              setInputTypeData(event?.target?.value);
              onChange(event?.target?.value);
            }}
            maxLength={metaType?.toLowerCase() === "short text" ? 30 : 200}
            inputClassName="rounded-none border-none"
          />
        </>
      );
    }
  } else if (type === "number") {
    return (
      <>
        <LabelComponent
          className="w-1/2 bg-[#F1F6F9] flex items-center py-1 px-3"
          htmlFor={id || name}
          labelText={name}
          size="small"
        />
        <InputComponent
          className="w-1/2"
          height="100%"
          id={id || name}
          type={type}
          placeholder={placeholder}
          value={inputTypeData}
          onChange={(event) => {
            setInputTypeData(event?.target?.value);
            onChange(event?.target?.value);
          }}
          inputClassName="rounded-none border-none"
        />
      </>
    );
  } else if (type === "date") {
    if (metaType === "DateTime") {
      const DD_MM_YYYY_DATE_FORMAT = moment(inputTypeData).format("YYYY-MM-DDTHH:mm");
      return (
        <>
          <LabelComponent
            className="w-1/2 bg-[#F1F6F9] flex items-center py-1 px-3"
            htmlFor={id || name}
            labelText={name}
            size="small"
          />
          <InputComponent
            className="w-1/2"
            height="100%"
            id={id || name}
            type="datetime-local"
            placeholder={placeholder || `Enter ${name}`}
            value={DD_MM_YYYY_DATE_FORMAT}
            onChange={(event) => {
              const value = moment(event?.target?.value).format("DD MMM YYYY HH:mm");
              setInputTypeData(value);
              onChange(value);
            }}
            inputClassName="rounded-none border-none"
          />
        </>
      );
    } else {
      const YYYY_MM_DD_DATE_FORMAT = moment(inputTypeData).format("YYYY-MM-DD");
      return (
        <>
          <LabelComponent
            className="w-1/2 bg-[#F1F6F9] flex items-center py-1 px-3"
            htmlFor={id || name}
            labelText={name}
            size="small"
          />
          <InputComponent
            className="w-1/2"
            height="100%"
            id={id || name}
            type="date"
            placeholder={placeholder || `Enter ${name}`}
            value={YYYY_MM_DD_DATE_FORMAT}
            onChange={(event) => {
              const value = moment(event?.target?.value).format("DD MMM YYYY HH:mm");
              setInputTypeData(value);
              onChange(value);
            }}
            inputClassName="rounded-none border-none"
          />
        </>
      );
    }
  } else if (type === "dropdown") {
    return (
      <>
        <LabelComponent
          className="w-1/2 bg-[#F1F6F9] flex items-center py-1 px-3"
          htmlFor={id || name}
          labelText={name}
          size="small"
        />
        <SelectComponent
          size="small"
          heightFull={true}
          id={id || name}
          label={name}
          options={options}
          value={value}
          onChange={(value) => {
            onChange([{ ...value[0], color_code: value[0]?.additionFields?.color_code }]);
          }}
          noFormInput={true}
          isRounded={false}
          hideBorder={true}
        />
      </>
    );
  } else if (type === "multiselect") {
    return (
      <>
        <LabelComponent
          className="w-1/2 bg-[#F1F6F9] flex items-center py-1 px-3"
          htmlFor={id || name}
          labelText={name}
          size="small"
        />
        <SelectComponent
          className="w-1/2"
          heightFull={true}
          size="small"
          id={id || name}
          label={name}
          options={options}
          value={value}
          style={{ height: "36px" }}
          onChange={(list) => {
            const modifiedList = list?.map((element) => {
              return { color_code: element?.additionFields?.color_code, ...element };
            });

            onChange(modifiedList);
          }}
          noFormInput={true}
          multiSelect={true}
          isRounded={false}
          hideBorder={true}
        />
      </>
    );
  } else if (type === "person" || type === "multi_person") {
    return (
      <>
        <LabelComponent
          className="w-1/2 bg-[#F1F6F9] flex items-center py-1 px-3"
          htmlFor={id || name}
          labelText={name}
          size="small"
        />
        <SelectComponent
          size="small"
          heightFull={true}
          className="w-1/2"
          id={id || name}
          label={name}
          options={options}
          value={inputTypeData || []}
          onChange={(list) => {
            setInputTypeData(list);
            onChange(list);
          }}
          personList
          multiSelect={type === "multi_person"}
          noFormInput={true}
          showSearch={true}
          hideBorder={true}
        />
      </>
    );
  } else {
    return (
      <>
        <LabelComponent
          className="w-1/2 bg-[#F1F6F9] flex items-center py-1 px-3"
          htmlFor={id || name}
          labelText={name}
          size="small"
        />
        <InputComponent
          className="w-1/2"
          height="100%"
          id={id || name}
          type="text"
          placeholder={placeholder || `Enter ${name}`}
          value={value}
          onChange={(event) => onChange(event?.target?.value)}
          inputClassName="rounded-none border-none"
        />
      </>
    );
  }
};

const FormDashboard = ({ onSubmit = () => {}, prefilledFormData = [] }) => {
  const [formInputData, setFormInputData] = useState(prefilledFormData);

  // Group form input data by sectionName
  const groupedFormData = formInputData?.reduce((acc, item) => {
    const section = item?.sectionName || "General";
    if (!acc[section]) acc[section] = [];
    acc[section].push(item);
    return acc;
  }, {});

  return (
    <div className="min-h-0 grow">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(formInputData);
        }}
        className="p-3 overflow-y-auto"
      >
        {Object.entries(groupedFormData).map(([sectionName, fields]) => (
          <div key={sectionName} className="mb-4">
            <div className="text-[#131313] font-semibold mb-2 font-Inter text-16">{getTitleCase(sectionName)}</div>
            <div className={`grid grid-cols-2 gap-3`}>
              {fields.map((inputData) => (
                <div className="flex min-h-[40px] border-[1px] border-gray-200" key={inputData?.name}>
                  {CheckTypeAndReturnHtmlInput({
                    id: inputData?.id,
                    name: inputData?.name,
                    type: inputData?.type,
                    placeholder: inputData?.placeholder,
                    value: inputData?.value,
                    options: inputData?.options,
                    metaType: inputData?.columnMetaType,
                    onChange: (value) => {
                      setFormInputData((prev) =>
                        prev.map((item) => (item?.name === inputData?.name ? { ...item, value } : item))
                      );
                    },
                  })}
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="flex justify-end">
          <Button type="submit">Save</Button>
        </div>
      </form>
    </div>
  );
};

export default FormDashboard;
